import React, {useState} from 'react';
import {withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import Divider from "@material-ui/core/Divider";
import FormField from "../../Form/FormField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import _ from "lodash";

const formatCorrespondence = (correspondence) => {
    return correspondence.map(item => {
        const regex = /\[(.*?)\]/;
        const str = item;
        let m;

        if ((m = regex.exec(str)) !== null) {
            return {
                sent_at: moment(m[1],['DD.MM.YYYY']).format('YYYY-MM-DD HH:mm:ss'),
                text: item.replace(m[0],m[1])
            }
        } else {
            return { text: item }
        }
    });//.filter(item => item.sent_at !== 'Invalid date');
}

const PDFAddendumDialog = (props) => {

    const {
        classes,
        values,
        changeAddendum,
        open,
        handleClose,
    } = props;

    const [correspondence,setCorrespondence] = useState('');
    const changeCorrespondence = text => setCorrespondence(text);

    const handleSubmit = () => {
        if(correspondence) {
            let newLines = formatCorrespondence(
                correspondence.split("\n").filter(item => item !== '' ) || []
            );
            let newOrder = _.orderBy(
                [...values.emails, ...newLines],
                ['sent_at'],
                ['asc']
            );

            changeAddendum( newOrder );
            handleClose();
        }
    }

    return (
        <Dialog
            open={open}
            onClose={() => handleClose(true)}
            disableBackdropClick={true}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="addendum-dialog-title"
            //aria-describedby="addendum-dialog-description"
        >
            <DialogTitle id="addendum-dialog-title" className={classes.dialogTitle}  disableTypography>
                <Typography variant="h6">{i18n.get('deficiency.dialog.complete_correspondence')}</Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <Icon>close</Icon>
                </IconButton>
                <div style={{fontSize:11,color:'#999999'}}>
                    {'Hinweis: Wenn in jeder Zeile ein Datum in eckige Klammern gesetzt wird, z.B. [18.12.2020], ' +
                    'dann wird die automatisch generierte Korrespondenzliste anhand dieser Datumsangaben neu ' +
                    'sortiert. Ansonsten werden alle neuen Zeilen unterhalb der Liste eingereiht.'}
                </div>
            </DialogTitle>
            <Divider/>
            <DialogContent>
                <form>
                    <FormField
                        type={'text'}
                        name={'correspondence_completions'}
                        label={i18n.get('deficiency.dialog.label_correspondences')}
                        className={classes.textArea}
                        multiline
                        rowsMax={5}
                        size="small"
                        placeholder={' '}
                        onBlur={input => changeCorrespondence(input.target.value)}
                        inputProps={{
                            style: {
                                padding:0,
                            },
                        }}
                    />
                </form>


            </DialogContent>
            <Divider />
            <DialogActions className={classes.dialogActions}>
                <Button
                    component={'a'}
                    variant={'contained'}
                    color={'primary'}
                    size={'small'}
                    onClick={handleSubmit}
                >{i18n.get('default.save')}</Button>
            </DialogActions>
        </Dialog>
    );
};

const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
        "& h6":{
            color: theme.colors.primary,
        },
    },
    dialogContent: {
        overflow:'visible',
    },
    dialogActions: {
        paddingTop: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
    },
    textArea: {
        padding:'0 !important',
        lineHeight: 1.5,
    }
});

export default withStyles(styles)(PDFAddendumDialog);
